import { getAllGuaranteesSuccess, startLoading } from 'redux/slices/all-guarantees'

const fetchAndDispatch = (QueryContractResponse, dispatch) => {
  const guaranteesReceived = QueryContractResponse?.entries
  dispatch(startLoading())
  dispatch(getAllGuaranteesSuccess(guaranteesReceived))
}

export default fetchAndDispatch
